import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shield } from 'lucide-react';
import LegalPageLayout from '../componnents/LegalPageLayout/LegalPageLayout';
import LegalSection from '../componnents/LegalPageLayout/LegalSection';
import LegalContactBlock from '../componnents/LegalPageLayout/LegalContactBlock';

const PrivacyPolicy = () => {
  const { t } = useTranslation('privacy');

  return (
    <LegalPageLayout
      icon={Shield}
      title={t('title')}
      subtitle={t('effectiveDate', { date: '2025-11-18' })}
      subtitleVariant="effective"
      backLabel={t('backToHome')}
    >
      <LegalSection>
        <p>{t('intro')}</p>
      </LegalSection>

      <LegalSection title={t('sections.infoCollection.title')}>
        <p>{t('sections.infoCollection.description')}</p>
        <ul>
          <li>{t('sections.infoCollection.items.ip')}</li>
          <li>{t('sections.infoCollection.items.pages')}</li>
          <li>{t('sections.infoCollection.items.time')}</li>
          <li>{t('sections.infoCollection.items.os')}</li>
        </ul>
        <p>{t('sections.infoCollection.location')}</p>
        <p>{t('sections.infoCollection.contact')}</p>
        <p>{t('sections.infoCollection.personalData')}</p>
      </LegalSection>

      <LegalSection title={t('sections.thirdParty.title')}>
        <p>{t('sections.thirdParty.description')}</p>
        <p>{t('sections.thirdParty.services')}</p>
        <ul>
          <li>
            <a href="https://expo.io/privacy" target="_blank" rel="noopener noreferrer">
              Expo
            </a>
          </li>
          <li>
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
              Google Play Services
            </a>
          </li>
          <li>
            <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">
              Google Firebase
            </a>
          </li>
        </ul>
        <p>{t('sections.thirdParty.disclosure')}</p>
        <ul>
          <li>{t('sections.thirdParty.disclosureItems.legal')}</li>
          <li>{t('sections.thirdParty.disclosureItems.safety')}</li>
          <li>{t('sections.thirdParty.disclosureItems.providers')}</li>
        </ul>
      </LegalSection>

      <LegalSection title={t('sections.optOut.title')}>
        <p>{t('sections.optOut.description')}</p>
      </LegalSection>

      <LegalSection title={t('sections.dataRetention.title')}>
        <p>{t('sections.dataRetention.description')}</p>
      </LegalSection>

      <LegalSection title={t('sections.children.title')}>
        <p>{t('sections.children.description')}</p>
        <p>{t('sections.children.action')}</p>
      </LegalSection>

      <LegalSection title={t('sections.security.title')}>
        <p>{t('sections.security.description')}</p>
      </LegalSection>

      <LegalSection title={t('sections.changes.title')}>
        <p>{t('sections.changes.description')}</p>
      </LegalSection>

      <LegalSection title={t('sections.consent.title')}>
        <p>{t('sections.consent.description')}</p>
      </LegalSection>

      <LegalContactBlock
        title={t('sections.contact.title')}
        description={t('sections.contact.description')}
      />
    </LegalPageLayout>
  );
};

export default PrivacyPolicy;
